import React from 'react';
import { FaTrophy, FaStar, FaBolt, FaFire, FaFutbol, FaMedal, FaShieldAlt } from 'react-icons/fa';

// Mapping nom de badge → { icone React, couleur hex }
export const BADGE_META = {
  'Premier But':           { Icon: FaTrophy,    color: '#FFB81C', bg: 'rgba(255,184,28,0.18)',  border: 'rgba(255,184,28,0.5)'  },
  'Hat-Trick':             { Icon: FaFire,      color: '#f97316', bg: 'rgba(249,115,22,0.18)',  border: 'rgba(249,115,22,0.5)'  },
  'Centurion':             { Icon: FaShieldAlt, color: '#60a5fa', bg: 'rgba(96,165,250,0.18)',  border: 'rgba(96,165,250,0.5)'  },
  'Sniper':                { Icon: FaBolt,      color: '#ef4444', bg: 'rgba(239,68,68,0.18)',   border: 'rgba(239,68,68,0.5)'   },
  'Champion':              { Icon: FaTrophy,    color: '#FFB81C', bg: 'rgba(255,184,28,0.18)',  border: 'rgba(255,184,28,0.5)'  },
  'Encyclopédie':          { Icon: FaStar,      color: '##003DA5', bg: 'rgba(34,197,94,0.18)',   border: 'rgba(34,197,94,0.5)'   },
  'Vitesse Éclair':        { Icon: FaBolt,      color: '#FFB81C', bg: 'rgba(255,184,28,0.18)',  border: 'rgba(255,184,28,0.5)'  },
  'Millionnaire':          { Icon: FaStar,      color: '#FFB81C', bg: 'rgba(255,184,28,0.18)',  border: 'rgba(255,184,28,0.5)'  },
  'Vainqueur Championnat': { Icon: FaTrophy,    color: '#FFB81C', bg: 'rgba(255,184,28,0.22)',  border: 'rgba(255,184,28,0.7)'  },
  'Finaliste Championnat': { Icon: FaMedal,     color: '#9ca3af', bg: 'rgba(156,163,175,0.18)', border: 'rgba(156,163,175,0.5)' },
  'Seigneur des Duels':    { Icon: FaBolt,      color: '#60a5fa', bg: 'rgba(96,165,250,0.18)',  border: 'rgba(96,165,250,0.5)'  },
  'Maître des Duels':      { Icon: FaFire,      color: '#ef4444', bg: 'rgba(239,68,68,0.18)',   border: 'rgba(239,68,68,0.5)'   },
  'Joueur Pro':            { Icon: FaStar,      color: '#9ca3af', bg: 'rgba(156,163,175,0.18)', border: 'rgba(156,163,175,0.5)' },
  'Joueur Élite':          { Icon: FaStar,      color: '#FFB81C', bg: 'rgba(255,184,28,0.18)',  border: 'rgba(255,184,28,0.5)'  },
  'Rookie':                { Icon: FaFutbol,    color: '##003DA5', bg: 'rgba(34,197,94,0.18)',   border: 'rgba(34,197,94,0.5)'   },
};

const DEFAULT_META = { Icon: FaShieldAlt, color: 'rgba(255,255,255,0.5)', bg: 'rgba(255,255,255,0.08)', border: 'rgba(255,255,255,0.2)' };

/**
 * Petit écusson de badge à afficher dans le duel sous le nom du joueur.
 * @param {object} badge   - objet badge depuis l'API {nom, description, ...}
 * @param {number} size    - taille en px (défaut 22)
 */
function BadgeShield({ badge, size = 22 }) {
  const meta = BADGE_META[badge?.nom] || DEFAULT_META;
  const { Icon, color, bg, border } = meta;
  const iconSize = Math.round(size * 0.52);

  return (
    <div
      title={badge?.nom || ''}
      style={{
        width:          size,
        height:         size,
        background:     bg,
        border:         `1px solid ${border}`,
        borderRadius:   Math.round(size * 0.3),
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        color,
        flexShrink:     0,
        boxShadow:      `0 0 6px ${border}`,
      }}
    >
      <Icon size={iconSize} />
    </div>
  );
}

export default BadgeShield;

